import React from 'react'
import { motion } from 'framer-motion'

const blobs = [
  { className: 'left-[5%] top-[10%] h-72 w-72 bg-blue-400/30', x: [0, 40, -20, 0], y: [0, -30, 20, 0] },
  { className: 'right-[10%] top-[20%] h-80 w-80 bg-violet-300/30', x: [0, -30, 30, 0], y: [0, 20, -20, 0] },
  { className: 'left-[35%] bottom-[5%] h-72 w-72 bg-cyan-300/30', x: [0, 20, -25, 0], y: [0, -20, 25, 0] }
]

export default function AnimatedBackground() {
  return (
    <div className="pointer-events-none fixed inset-0 -z-10 overflow-hidden bg-transparent">
      {blobs.map((b, i) => (
        <motion.div
          key={i}
          className={`absolute rounded-full blur-3xl ${b.className}`}
          animate={{ x: b.x, y: b.y }}
          transition={{ duration: 24 + i * 4, repeat: Infinity, ease: 'easeInOut' }}
        />
      ))}
    </div>
  )
}
